// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.purposeAreaEmployee-main .area-checked {
  height: auto;
  display: flex;
  flex-wrap: wrap;
}
.purposeAreaEmployee-main .area-checked span {
  background: linear-gradient(45deg, #44c3fa 20%, #6d72f9 100%);
  box-shadow: 3px 7px 5px rgba(0, 0, 0, 0.02), 7px 15px 17.9px rgba(0, 0, 0, 0.12), 24px 50px 80px rgba(0, 0, 0, 0.4);
  padding: 0 10px;
  margin: 5px;
  border-radius: 50rem;
  color: white;
  height: 25px;
}
.purposeAreaEmployee-main .select-multiple {
  cursor: pointer;
  width: auto;
  background: linear-gradient(90deg, rgb(68, 195, 250) 0%, rgb(56, 211, 213) 100%);
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 8px;
  padding: 0 3px 8px 3px;
  transition: height 0.5s ease;
}
.purposeAreaEmployee-main .select-multiple svg {
  color: white;
}
.purposeAreaEmployee-main .select-multiple.close {
  height: 80px;
}
.purposeAreaEmployee-main .select-multiple.open {
  height: 340px;
}
.purposeAreaEmployee-main .select-multiple span {
  font-weight: bold;
  color: white;
  padding: 10px;
}
.purposeAreaEmployee-main .select-multiple ul {
  width: 100%;
  height: 300px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  background: white;
  list-style: none;
  border-radius: 0 0 7px 7px;
}
.purposeAreaEmployee-main .select-multiple ul li {
  border-bottom: 1px solid #e0e0e0;
  padding: 10px;
  color: #bababa;
}
.purposeAreaEmployee-main .select-multiple ul li:last-child {
  border: none;
}
.purposeAreaEmployee-main .select-multiple ul li.select-active {
  color: #1a1a1a;
}
.purposeAreaEmployee-main .select-multiple ul li:hover {
  background: rgba(0, 0, 0, 0.05);
}`, "",{"version":3,"sources":["webpack://./src/Views/Employee/Components/PurposesArea/purposeArea.sass"],"names":[],"mappings":"AAEI;EACI,YAAA;EACA,aAAA;EACA,eAAA;AADR;AAGQ;EACI,6DAAA;EACA,mHAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,YAAA;EACA,YAAA;AADZ;AAGI;EACI,eAAA;EACA,WAAA;EACA,gFAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;AADR;AAGQ;EACI,YAAA;AADZ;AAGQ;EACI,YAAA;AADZ;AAGQ;EACI,aAAA;AADZ;AAGQ;EACI,iBAAA;EACA,YAAA;EACA,aAAA;AADZ;AAGQ;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AADZ;AAGY;EACI,gCAAA;EACA,aAAA;EACA,cAAA;AADhB;AAGY;EACI,YAAA;AADhB;AAGY;EACI,cAAA;AADhB;AAGY;EACI,+BAAA;AADhB","sourcesContent":[".purposeAreaEmployee-main\n\n    .area-checked\n        height: auto\n        display: flex\n        flex-wrap: wrap\n\n        span\n            background: linear-gradient(45deg, #44c3fa 20%, #6d72f9 100%)\n            box-shadow: 3px 7px 5px rgba(0, 0, 0, 0.02), 7px 15px 17.9px rgba(0, 0, 0, 0.12), 24px 50px 80px rgba(0, 0, 0, 0.4)\n            padding: 0 10px\n            margin: 5px\n            border-radius: 50rem\n            color: white\n            height: 25px\n\n    .select-multiple\n        cursor: pointer\n        width: auto\n        background: linear-gradient(90deg, rgba(68,195,250,1) 0%, rgba(56,211,213,1) 100%)\n        display: flex\n        align-items: center\n        flex-direction: column\n        border-radius: 8px\n        padding: 0 3px 8px 3px\n        transition: height .5s ease\n\n        svg\n            color: white\n\n        &.close\n            height: 80px\n\n        &.open\n            height: 340px\n\n        span\n            font-weight: bold\n            color: white\n            padding: 10px\n\n        ul\n            width: 100%\n            height: 300px\n            overflow-y: auto\n            margin: 0\n            padding: 0\n            background: white\n            list-style: none\n            border-radius: 0 0 7px 7px\n\n            li\n                border-bottom: 1px solid #e0e0e0\n                padding: 10px\n                color: #bababa\n\n            li:last-child\n                border: none\n\n            li.select-active\n                color: #1a1a1a\n\n            li:hover\n                background: rgba(0,0,0,.05)\n                "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
